import { render } from "./BFaQ.vue?vue&type=template&id=88b88aaa&scoped=true"
import script from "./BFaQ.vue?vue&type=script&lang=js"
export * from "./BFaQ.vue?vue&type=script&lang=js"

import "./BFaQ.vue?vue&type=style&index=0&id=88b88aaa&scoped=true&lang=scss"

import exportComponent from "/tmp/build_195c5171/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88b88aaa"]])

export default __exports__